import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Equipo } from 'src/app/administracion/modelos/Inventario/Equipo/equipo';
import { EquipoService } from 'src/app/administracion/servicios/Inventario/Equipo/equipo.service';
import Swal from 'sweetalert2';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UsuarioGlpiService } from 'src/app/administracion/servicios/Inventario/Usuario/usuario-glpi.service';
import { RegistroAsignacionEquipoService } from 'src/app/administracion/servicios/Asignacion_Equipo/registro-asignacion-equipo.service';
import { DetalleRegistroService } from 'src/app/administracion/servicios/Asignacion_Equipo/detalle-registro.service';
import { SolicitudAsigEquipoService } from 'src/app/administracion/servicios/Asignacion_Equipo/solicitud-asig-equipo.service';
import { RegistroAsignacionEquipo } from 'src/app/administracion/modelos/Asignacion_Equipo/registro-asignacion-equipo';
import { DetalleRegistro } from 'src/app/administracion/modelos/Asignacion_Equipo/detalle-registro';
import { UsuarioService } from 'src/app/administracion/servicios';
import { Empleado } from 'src/app/administracion/modelos/empleado';
import { Sucursal } from 'src/app/administracion/modelos/sucursal';
import { map, switchMap } from 'rxjs/operators';
import { forkJoin, combineLatest } from 'rxjs';

@Component({
  selector: 'app-asignacion-computadora-escritorio',
  templateUrl: './asignacion-computadora-escritorio.component.html',
  styleUrls: ['./asignacion-computadora-escritorio.component.scss'],
})
export class AsignacionComputadoraEscritorioComponent implements OnInit {
  @ViewChild('buscador', { static: true }) buscador!: ElementRef;
  @ViewChild(MatPaginator) paginator!: MatPaginator; /* Paginator de la tabla */

  nombreTabla: string = 'MONITORES';
  tabla: string = 'Monitor';
  /* Índice para saber en que tabla buscar                          */
  indice: number = 2;
  /* Filtro para indicar que tipo de equipo buscar tabla de equipos */
  filtro: string = '';
  /*Elementos de la data de la tabla de equipos*/
  dataSource = new MatTableDataSource<Equipo>([]); /* Data de la tabla      */
  /* Encabezados genéricos */
  encabezados: string[] = [
    'OPCIONES',
    'NOMBRE',
    'NÚMERO DE SERIE',
    'TIPO',
    'MODELO',
    'FABRICANTE',
  ];
  empleado_asignado!: Empleado; /* Modelo u objeto empleado al que se le va asignar los equipos*/
  /** Parámetros a capturar */
  id_cpu!: number;
  comen_cpu!: string;
  nombre_cpu!: string;
  id_colaborador!: number;
  nombre!: string;
  apellidos!: string;
  tipoAsignacion!: string;

  formularioDispositivos = new FormGroup({
    cpu: new FormGroup({
      id: new FormControl(null, [Validators.required]),
      nombre: new FormControl(null, [Validators.required]),
      observaciones: new FormControl(null, []),
    }),
    monitor: new FormGroup({
      id: new FormControl(null, [Validators.required]),
      nombre: new FormControl(null, [Validators.required]),
      observaciones: new FormControl(null, []),
    }),
    teclado: new FormGroup({
      id: new FormControl(null, [Validators.required]),
      nombre: new FormControl(null, [Validators.required]),
      observaciones: new FormControl(null, []),
    }),
    mouse: new FormGroup({
      id: new FormControl(null, [Validators.required]),
      nombre: new FormControl(null, [Validators.required]),
      observaciones: new FormControl(null, []),
    }),
    regulador: new FormGroup({
      id: new FormControl(null, []),
      nombre: new FormControl(null, []),
      observaciones: new FormControl(null, []),
    }),
  });

  constructor(
    private readonly equipoService: EquipoService /* Conexión con la tabla equipos de Glpi*/,
    private readonly activatedRoute: ActivatedRoute,
    private readonly usuarioGlpiService: UsuarioGlpiService /* Conexión con la tabla usuarios de Glpi*/,
    private readonly router: Router,
    private readonly registroAsignacionEquipoService: RegistroAsignacionEquipoService /* Conexión con la tabla registro asignacin de la base de datos*/,
    private readonly detalleResgistroService: DetalleRegistroService /* Conexión con la tabla detalle de registro  de la base de datos*/,
    private readonly solicitudAsigEquipoService: SolicitudAsigEquipoService /* Conexión con la tabla solicitudes de equipos de la base de datos */,
    private readonly usuarioService: UsuarioService /* Conexión con el endpoint empleados*/
  ) {}

  ngOnInit() {
    /* Capturamos los paràmetros enviados a travez de la URL */
    combineLatest([
      this.activatedRoute.params,
      this.activatedRoute.queryParams,
    ]).subscribe({
      next: ([params, queryParams]) => {
        this.id_cpu = params['id_computadora'];
        this.tipoAsignacion = params['asignacion'];
        this.id_colaborador = params['id_empleado'];

        this.nombre = queryParams['nombre_empleado'];
        this.apellidos = queryParams['apellidos_empleado'];
        this.nombre_cpu = queryParams['nombre_equipo'];
        this.comen_cpu = queryParams['comentarios'];

        /* Cargamos los datos del equipo seleccionado */
        this.formularioDispositivos.get('cpu')?.setValue({
          id: this.id_cpu,
          nombre: this.nombre_cpu,
          observaciones: this.comen_cpu,
        });

        this.llenarData();
      },
    });
  }

  get cpuFormulario() {
    return this.formularioDispositivos.get('cpu');
  }

  get monitorFormulario() {
    return this.formularioDispositivos.get('monitor');
  }

  get tecladoFormulario() {
    return this.formularioDispositivos.get('teclado');
  }

  get mouseFormulario() {
    return this.formularioDispositivos.get('mouse');
  }

  get reguladorFormulario() {
    return this.formularioDispositivos.get('regulador');
  }

  cargarTabla(codigo: number) {
    // limpiar el buscador
    this.buscador.nativeElement.value = '';
    this.dataSource.filter = '';

    /*Compara el valor del recibido en los parámetros */
    switch (codigo) {
      /* De elegir las comutadoras, carga la tabla de equipos con las Cpu disponibles en ese momento */
      case 1:
        /*Cambiamos el nombre de la tabla indicando que equipos está mostrando  */
        this.nombreTabla = "COMPUTADORAS (CPU's)";
        /*Filtro para caragra solo las Cpu                                      */
        this.filtro = 'CPU';
        /* Aquí le decimos que el equipo seleccionado se irá a la posicion 1    */
        this.indice = 1;
        /* Aquí le decimos que debe buscar en la tabla Computer                 */
        this.tabla = 'Computer';
        this.llenarData();
        break;

      case 2:
        this.nombreTabla = 'MONITORES';
        this.filtro = 'MON';
        this.indice = 2;
        this.tabla = 'Monitor';
        this.llenarData();
        break;

      case 3:
        this.nombreTabla = 'TECLADOS';
        this.filtro = 'TECLADO';
        this.indice = 3;
        this.tabla = 'Peripheral';
        this.llenarData();
        break;

      case 4:
        this.nombreTabla = 'MOUSES';
        this.filtro = 'MOUSE';
        this.indice = 4;
        this.tabla = 'Peripheral';
        this.llenarData();
        break;

      case 5:
        this.nombreTabla = 'REGULADORES';
        this.filtro = 'REGULADOR';
        this.indice = 5;
        this.tabla = 'Peripheral';
        this.llenarData();
        break;
    }
  }

  /*
     CUANDO SE DA CLICK EN EL EQUPO A ASIGNAR, SE CARGA EN EL ARRAY EL ID DEL EQUIPO Y SE AGREGA EL NOMBRE DEL 
     EQUIPO PARA SABER QUE EQUIPO A SE SELECCIONÓ 
  */
  seleccionarEquipo(nombre: string, id_equipo: number) {
    if (this.indice === 1) {
      this.cpuFormulario?.setValue({
        id: id_equipo,
        nombre: nombre,
        observaciones: this.cpuFormulario?.get('observaciones')?.value,
      });
    }
    if (this.indice === 2) {
      this.monitorFormulario?.setValue({
        id: id_equipo,
        nombre: nombre,
        observaciones: this.monitorFormulario?.get('observaciones')?.value,
      });
    }
    if (this.indice === 3) {
      this.tecladoFormulario?.setValue({
        id: id_equipo,
        nombre: nombre,
        observaciones: this.tecladoFormulario?.get('observaciones')?.value,
      });
    }
    if (this.indice === 4) {
      this.mouseFormulario?.setValue({
        id: id_equipo,
        nombre: nombre,
        observaciones: this.mouseFormulario?.get('observaciones')?.value,
      });
    }
    if (this.indice === 5) {
      this.reguladorFormulario?.setValue({
        id: id_equipo,
        nombre: nombre,
        observaciones: this.reguladorFormulario?.get('observaciones')?.value,
      });
    }
  }

  /* Carga la tabla con los equipos disponibles, por defecto carga los monitores ya que en las pantallas 
    anteriores se seleccionó al Cpu*/
  llenarData() {
    /*Removemos el contenido de la tabla */
    this.dataSource.data = [];

    let listaAux: Equipo[] = [];

    /* Realizamos la consulta con la tabla actual*/
    this.equipoService
      .todosLosEquipos(this.tabla)
      .pipe(
        map((data) =>
          data.filter(
            (element) =>
              element.states_id === 'Stock' ||
              element.states_id === 'No Asignado' ||
              element.states_id === 'Principal' ||
              element.states_id === 'Backup' ||
              element.states_id === ''
          )
        )
      )
      .subscribe(
        (lista) => {
          /*Recorremos la consulta obtenida */
          lista.forEach((element) => {
            /*Computadoras */
            if (this.indice == 1) {
              /* Cargamos en tipo y modelo del equipo los campos de tipo y modelo de una computadora */
              element.tipo = element.computertypes_id;
              element.modelo = element.computermodels_id;
              /* Filtramos que sean solo cpu's */
              if (element.name.includes(this.filtro)) {
                listaAux.push(element);
              }
            } else if (this.indice == 2) {
              /*Monitor */
              element.tipo = element.monitortypes_id;
              element.modelo = element.monitormodels_id;
              /* Filtramos que sean solo cpu's */
              if (element.name.includes('')) {
                listaAux.push(element);
              }
            } else {
              /*Regulador, teclado y mouse */
              /* Cargamos en tipo y modelo del equipo los campos de tipo y modelo de un periférico */
              element.tipo = element.peripheraltypes_id;
              element.modelo = element.peripheralmodels_id;
              /*Filtra los tipos de equipo para el caso de regulador, teclado y mouse */
              if ((element.tipo + '').includes(this.filtro)) {
                listaAux.push(element);
              }
            }
          });

          /* En caso que no se tengan equipos disponibles se retorna un mensaje de error */
          if (listaAux.length == 0) {
            Swal.fire({
              title: 'Información',
              text: 'No hay equipos disponibles, intentelo más tarde',
              icon: 'info',
              timer: 2000,
            });

            return;
          }

          /* ENVIA LOS EQUIPOS DISPONIBLES AL DATA SOURCE */
          this.dataSource.data = listaAux;
          this.dataSource.paginator = this.paginator;
        },
        (err) => {
          /* En caso de tenenr problemas para retornar los equipos, emerge un mensaje de error */
          Swal.fire({
            showConfirmButton: false,
            allowEnterKey: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            timer: 3000,
            icon: 'error',
            title: 'Sin conexión con el servidor, intentelo más tarde',
          });
        }
      );

    /*cargamos los datos del empleado */
    this.usuarioService.getAnEmpleado(this.id_colaborador).subscribe(
      (data) => {
        this.empleado_asignado = data;
      },
      /* En caso que se tenga problemas de conexión se retorna un mensaje de error */
      (err) => {
        Swal.fire({
          showConfirmButton: false,
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          timer: 3000,
          icon: 'error',
          title: 'Error al cargar los datos del empleado, intentelo más tarde',
        });
      }
    );
  }

  filtroDataSource(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /* Asigna los equipo seleccioandos al empleado */
  async asignar() {
    /*Primero revisamos que todos los componentes fueran seleccionados */
    if (this.formularioDispositivos.invalid) {
      /*En el improbable caso que no se selecione alguno de estos equipos retorna un mensajde error */
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No has seleccionado todos los componentes de la computadora',
        timer: 1700,
      });
      return;
    }

    /*Comenzamos preguntando si se está seguro de realizar esta asignación */
    const result = await Swal.fire({
      title: '¿Está seguro de realizar esta asignación?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'SÍ',
      cancelButtonText: 'NO',
    });

    if (!result.isConfirmed) {
      return;
    }

    /* creamos un objeto para cuando la sucursal sea nula */
    let sucursal_obj: Sucursal = new Sucursal();
    sucursal_obj.nombreSucursal = 'Sin sucursal a buscar';

    let nombrePuesto = '';

    this.usuarioService
      .getAnEmpleado(this.id_colaborador)
      .pipe(
        switchMap((empleado) => {
          nombrePuesto = empleado.puesto.nombrePuesto + '';

          if (empleado.sucursal == null) {
            /* De tenerlo solo agrega el valor por defecto */
            empleado.sucursal = sucursal_obj;
          }

          return forkJoin([
            this.equipoService.buscarSucursal(empleado.sucursal.nombreSucursal),
            this.usuarioGlpiService.allUsuariosSearch(
              this.nombre,
              this.apellidos
            ),
          ]);
        })
      )
      .subscribe(
        ([sucursales, val]) => {
          let body: string = '';

          /* validamos que las consultas no estèn vacías */
          if (sucursales.length <= 0) {
            /* En caso de no recibir nada retornamos un mensaje de error */
            this.mensajeDeError2(
              'La sucursal a la que pertenece el empleado no se encuentra registrada en Glpi'
            );
            return;
          }

          /* Primero validamos las sucursales */
          if (val.length <= 0) {
            /* En caso de no recibir nada retornamos un mensaje de error */
            this.mensajeDeError2(
              'El empleado seleccionado no se encuentra registrado en Glpi'
            );
            return;
          }

          /* Ahora validamos al Empleado */
          /*Actualizamos los equipos en Glpi */
          body =
            '{"input": {"states_id": " ' +
            1 +
            +' ", "contact": " ' +
            nombrePuesto +
            ' ", "users_id": " ' +
            val[0].id +
            ' ", "locations_id": " ' +
            sucursales[0].id +
            '"}}';

          const observables = [
            /* Cpu       */
            this.equipoService.actualizarItem(
              'Computer',
              Number(this.cpuFormulario?.get('id')?.value),
              body
            ),
            /* Monitor   */
            this.equipoService.actualizarItem(
              'Monitor',
              Number(this.monitorFormulario?.get('id')?.value),
              body
            ),
            /* Teclado   */
            this.equipoService.actualizarItem(
              'Peripheral',
              Number(this.tecladoFormulario?.get('id')?.value),
              body
            ),
            /* Mouse     */
            this.equipoService.actualizarItem(
              'Peripheral',
              Number(this.mouseFormulario?.get('id')?.value),
              body
            ),
          ];

          // si el usuario selecciona un regulador se actualiza en la base de datos
          if (this.reguladorFormulario?.get('id')?.value) {
            observables.push(
              /* Regulador */
              this.equipoService.actualizarItem(
                'Peripheral',
                Number(this.reguladorFormulario?.get('id')?.value),
                body
              )
            );
          }

          forkJoin(observables).subscribe(
            () => {
              /* Creamos el registro general */
              let registroAsignacionEquipo: RegistroAsignacionEquipo =
                new RegistroAsignacionEquipo();
              registroAsignacionEquipo.id_registro_asignacion = 0;
              registroAsignacionEquipo.status_registro = 'REGISTRADO';
              registroAsignacionEquipo.colaborador_id = this.id_colaborador;
              registroAsignacionEquipo.fecha_asignacion = new Date();
              registroAsignacionEquipo.fecha_modificacion = new Date();
              registroAsignacionEquipo.nombre_empleado_asignado =
                this.empleado_asignado.nombre +
                ' ' +
                this.empleado_asignado.apellidoPat +
                ' ' +
                this.empleado_asignado.apellidoMat;

              /*Validamos si se tiene una solicitud o si es una asignación directa */
              if (this.tipoAsignacion == 'directa') {
                /* De ser directa se realiza el post para guardar este registro general y el resultado es usado 
                  para asignarlo a los detalles de registro */
                this.asignacionDirecta(registroAsignacionEquipo);
              } else {
                /** Para una asignacion que viene de solicitud enviamos el registro y el id de la solicitud */
                /* De ser con solicitud se agrega el id de la solictud al realizar el post para guardar este registro general y el 
                resultado es usado para asignarlo a los detalles de registro */
                this.asignacionIndirecta(registroAsignacionEquipo);
              }
            },
            (error) => {
              this.mensajeDeerror();
            }
          );
        },
        (err) => {
          this.mensajeDeerror();
        }
      );
  }

  asignacionDirecta(registroAsignacionEquipo: RegistroAsignacionEquipo) {
    registroAsignacionEquipo.observaciones = 'ASIGNACIÓN DIRECTA';
    this.registroAsignacionEquipoService
      .asignacionD(registroAsignacionEquipo)
      .subscribe(
        (data) => {
          this.generarDetalleRegistro(
            Number(data.id_registro_asignacion)
          ).subscribe(
            () => {
              /*Desplegamos en pantalla un mensaje de confirmación */
              this.mensajeDeAsignacionRealizada();
            },
            () => {
              this.mensajeDeerror();
            }
          );
        },
        (err) => {
          this.mensajeDeerror();
        }
      );
  }

  asignacionIndirecta(registroAsignacionEquipo: RegistroAsignacionEquipo) {
    registroAsignacionEquipo.observaciones = 'ASIGNACIÓN CON SOLICITUD';
    let id_solicitud: number = Number(this.tipoAsignacion);
    this.registroAsignacionEquipoService
      .asignacionI(registroAsignacionEquipo, id_solicitud)
      .subscribe(
        (data) => {
          this.generarDetalleRegistro(
            Number(data.id_registro_asignacion)
          ).subscribe(
            () => {
              /** Cambiamos el status de la solicitud por "APROBADO" */
              this.aprobarSolicitud();

              /*Desplegamos en pantalla un mensaje de confirmación */
              this.mensajeDeAsignacionRealizada();
            },
            () => {
              this.mensajeDeerror();
            }
          );
        },
        (err) => {
          this.mensajeDeerror();
        }
      );
  }

  /*Cancela el proceso de asignacion de la computadora de escritorio */
  cancelar() {
    /* Pedimos confirmación para cancelar este proceso de asignación */
    Swal.fire({
      title: '¿Está seguro de cancelar está asignación?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'SÍ',
      cancelButtonText: 'NO',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
    }).then((result) => {
      /* DE CONFIRMAR ESTA PREGUNTA NOS REDIRIGIMOS A LA VISTA QUE CORRESPONDA */
      if (result.isConfirmed) {
        /* SI VENIMOS DE LA ASIGNACIÓN DIRECTA NOS REDIRIGGE A LA VISTA DE ASIGNACIONES SDIRECTAS */
        if (this.tipoAsignacion == 'directa') {
          this.router.navigate(['layout/asignacionDirecta']);
        } else {
          /**DE CONTAR CON SOLICITUD NOS REDIRIGE A VER LA GESTION DE SOLICITUDES */
          this.router.navigate(['layout/solicitudesDeEquipoAdministrador']);
        }
      }
    });
  }

  /*Método que cambia el status de la solicitud de equipo por APROBADO */
  aprobarSolicitud() {
    let id_solicitud: number = Number(
      this.tipoAsignacion
    ); /*Cargamos el Id de la solicitud */
    this.solicitudAsigEquipoService
      .solicitudPorIdSolicitud(id_solicitud)
      .subscribe((data) => {
        /*Buscamos la solictud por su Id */
        data.fecha_mod =
          new Date().toISOString(); /*  Agregamos la fecha de modificación */
        data.status_solicitud = 'APROBADO'; /*  Agregamos el nuevo estado */
        this.solicitudAsigEquipoService.update(data).subscribe(
          (val) => {},
          (err) => {
            this.mensajeDeerror();
          }
        ); /*Realizamos el cambio */
      });
  }

  /* GENERA LOS 5 DETALLES DE ASIGNACION DE UN EQUIPO DE ESCRITORIO */
  generarDetalleRegistro(id_registro_asignacion: number) {
    /* CREAMOS UN DETALLE QUE SERVIRA DE BASE PARA AGREGARLOS AL REGISTRO DEL EQUIPO DE ESCRITORIO */
    /* CPU*/
    const detalleRegistroCPU: DetalleRegistro = new DetalleRegistro();
    detalleRegistroCPU.status_detalle = 'ACTIVO';
    detalleRegistroCPU.equipo_id = this.cpuFormulario?.get('id')?.value;
    detalleRegistroCPU.nombre_equipo = this.cpuFormulario?.get('nombre')?.value;
    detalleRegistroCPU.tipo_activo = 'COMPUTADORA';
    detalleRegistroCPU.observ_equipo =
      this.cpuFormulario?.get('observaciones')?.value || 'SIN COMENTARIOS';

    /* MONITOR   */
    const detalleRegistroMonitor: DetalleRegistro = new DetalleRegistro();
    detalleRegistroMonitor.status_detalle = 'ACTIVO';
    detalleRegistroMonitor.nombre_equipo =
      this.monitorFormulario?.get('nombre')?.value;
    detalleRegistroMonitor.equipo_id = this.monitorFormulario?.get('id')?.value;
    detalleRegistroMonitor.tipo_activo = 'MONITOR';
    detalleRegistroMonitor.observ_equipo =
      this.monitorFormulario?.get('observaciones')?.value || 'SIN COMENTARIOS';

    /* TECLADO   */
    const detalleRegistroTeclado: DetalleRegistro = new DetalleRegistro();
    detalleRegistroTeclado.status_detalle = 'ACTIVO';
    detalleRegistroTeclado.nombre_equipo =
      this.tecladoFormulario?.get('nombre')?.value;
    detalleRegistroTeclado.equipo_id = this.tecladoFormulario?.get('id')?.value;
    detalleRegistroTeclado.tipo_activo = 'DISPOSITIVO';
    detalleRegistroTeclado.observ_equipo =
      this.tecladoFormulario?.get('observaciones')?.value || 'SIN COMENTARIOS';

    /* MOUSE     */
    const detalleRegistroMouse: DetalleRegistro = new DetalleRegistro();
    detalleRegistroMouse.status_detalle = 'ACTIVO';
    detalleRegistroMouse.nombre_equipo =
      this.mouseFormulario?.get('nombre')?.value;
    detalleRegistroMouse.equipo_id = this.mouseFormulario?.get('id')?.value;
    detalleRegistroMouse.tipo_activo = 'DISPOSITIVO';
    detalleRegistroMouse.observ_equipo =
      this.mouseFormulario?.get('observaciones')?.value || 'SIN COMENTARIOS';

    /* REGULADOR */
    const detalleRegistroRegulador: DetalleRegistro = new DetalleRegistro();
    detalleRegistroRegulador.status_detalle = 'ACTIVO';
    detalleRegistroRegulador.nombre_equipo =
      this.reguladorFormulario?.get('nombre')?.value;
    detalleRegistroRegulador.equipo_id =
      this.reguladorFormulario?.get('id')?.value;
    detalleRegistroRegulador.tipo_activo = 'DISPOSITIVO';
    detalleRegistroRegulador.observ_equipo =
      this.reguladorFormulario?.get('observaciones')?.value ||
      'SIN COMENTARIOS';

    const observables = [
      this.detalleResgistroService.agregarDetalleAsignacion(
        detalleRegistroCPU,
        id_registro_asignacion
      ),
      this.detalleResgistroService.agregarDetalleAsignacion(
        detalleRegistroMonitor,
        id_registro_asignacion
      ),
      this.detalleResgistroService.agregarDetalleAsignacion(
        detalleRegistroTeclado,
        id_registro_asignacion
      ),
      this.detalleResgistroService.agregarDetalleAsignacion(
        detalleRegistroMouse,
        id_registro_asignacion
      ),
    ];

    // si seleccionó regulador, agregarlo a la base de datos
    if (this.reguladorFormulario?.get('id')?.value) {
      observables.push(
        this.detalleResgistroService.agregarDetalleAsignacion(
          detalleRegistroRegulador,
          id_registro_asignacion
        )
      );
    }

    return forkJoin(observables);
  }

  /* Despliega una ventana con información de l ventana */
  clickMasInformacion(event: any) {
    Swal.fire({
      title: 'Asignación de computadora de escritorio',
      html:
        '<p align="justify"> Inicialmente se carga la CPU del equipo. Ahora solo hace falata elegir ' +
        'el resto de componentes: <b>MONITOR</b>, <b>TECLADO</b>, <b>MOUSE</b> Y <b>REGULADOR</b>.</p>' +
        '<p align="justify">Los botones que se encuentran arriba de la tabla de selección ' +
        ' cargan los equipos disponibles.</p>' +
        '<p align="justify">Para elegir los componentes solo hay que dar click en los botones que se ' +
        'encuentran al inicio de cada fila de la tabla. Igualmente se pueden agregar observaciones o coment' +
        'arios a cada componente.</p>' +
        '<p align="justify">Para terminar la asignación seleccione el botón azul con la etiqueta <b>Asignar</b>.</p>',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Cerrar',
    });
  }

  /*Método que despiega un mensaje de error de conexión */
  mensajeDeerror() {
    Swal.fire({
      icon: 'error',
      title: 'Sin conexión, intentelo más tarde',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      timer: 3000,
    });
  }
  /*Método que despiega un mensaje de error de conexión */
  mensajeDeError2(texto: string) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: texto,
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      timer: 3000,
    });
  }

  mensajeDeAsignacionRealizada() {
    /* Mostramos un mensaje de confirmación */
    Swal.fire({
      icon: 'success',
      title: 'Asignación realizada con éxito',
      showConfirmButton: false,
      timer: 2000,
    }).then((r) => {
      /** Nos redirigimos a otra vista donde mostramos los registros sin subir responsiva */
      this.router.navigate(['layout/seguimientoAsignacionEquipo']);
    });
  }

  quitarRegulador() {
    this.reguladorFormulario?.reset();
  }
}
